<template>
    <div :class="['modal', show ? 'is-active' : '']">
        <div class="modal-background" @click.self="closeByBackground"></div>
        <div class="modal-card" :class="modalCardClass">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <slot name="title"></slot>
                </p>
                <button class="delete" aria-label="close" @click="close"></button>
            </header>
            <section class="modal-card-body">
                <slot name="body"></slot>
            </section>
            <footer class="modal-card-foot">
                <slot name="footer"></slot>
            </footer>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from "vue";
    import { useModalStack } from "./useModalStack";

    const props = defineProps<{
        modalCardClass?: string;
        preventCloseByBackground?: boolean;
    }>();

    const emit = defineEmits<{
        closed: [];
    }>();

    const show = ref(false);

    const { pushOpen, popClose } = useModalStack(close);

    function open() {
        pushOpen();
        show.value = true;
    }

    function closeByBackground() {
        if (props.preventCloseByBackground) {
            return;
        }

        close();
    }

    function close() {
        if (!popClose()) {
            return;
        }

        show.value = false;
        emit("closed");
    }

    defineExpose({ open, close });
</script>

<style scoped>
    .modal-card-foot {
        justify-content: flex-end;
    }

    .modal-card-title {
        flex-shrink: unset;
    }
</style>
